import React from 'react'
import PropTypes from 'prop-types'

import Breadcrumb from 'components/Breadcrumb'
import Loading from 'components/Loading'

import PageTitle from './PageTitle'
import Content from './Content'
import Action from './Action'
import Portfolios from './Portfolios'

const Portfolio = props => (
  <div className="page-content">
    {props.isLoading && (<Loading />)}
    <Breadcrumb data={props} />
    <div className="row">
      <PageTitle />
    </div>

    <Portfolios />

    <div className="row margin-bottom-20">
      <div className="col-lg-9 col-md-6">
        <Content />
      </div>
      <div className="col-lg-3 col-md-6">
        <Action />
      </div>
    </div>
  </div>
)

Portfolio.propTypes = {
  isLoading: PropTypes.bool.isRequired,
}

export default Portfolio
